import { RegisterOptions } from 'react-hook-form';
import { REQUIRED_MESSAGES } from './requiredMessage';

/**
 * Единое правило валидации обязательного текстового поля для react-hook-form.
 *
 * Требует непустое значение и отвергает строку, состоящую только из пробелов
 * (чего обычное `required` не отлавливает). Используется во всех модалках
 * действий, чтобы обязательные текстовые поля (Комментарий, Текст задачи,
 * Причина и т. п.) обрабатывались консистентно.
 *
 * @param message текст ошибки (по умолчанию «Заполните поле»)
 */
export const requiredTextRules = (message: string = REQUIRED_MESSAGES.text): RegisterOptions => ({
    required: message,
    validate: (value?: string) => (typeof value === 'string' && value.trim().length > 0) || message,
});
